import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "2 2 14 14",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.111 5.941 C 2.983 5.963,2.869 6.038,2.779 6.159 C 2.695 6.272,2.677 6.557,2.745 6.693 C 2.812 6.826,8.168 12.193,8.325 12.283 C 8.490 12.379,8.591 12.397,8.739 12.359 C 8.851 12.329,9.167 12.025,11.651 9.545 C 13.276 7.922,14.454 6.725,14.478 6.668 C 14.578 6.440,14.491 6.151,14.282 6.013 C 14.150 5.925,13.896 5.904,13.768 5.969 C 13.728 5.990,12.551 7.149,11.153 8.545 L 8.610 11.085 6.053 8.529 C 4.106 6.584,3.474 5.969,3.405 5.955 C 3.247 5.922,3.227 5.921,3.111 5.941 ",
		stroke: "none",
		fillRule: "evenodd"
	})
});
export default SvgCaretDown;
